
import isUndefined from 'lodash/isUndefined'
import isEmpty from 'lodash/isEmpty'
import $api from '@/plugins/axiosInstance.js'
import $api2 from '@/plugins/axiosInstance2.js'
import CONST from '@/const'

const state = {
    ownerList: null   // 권리자 리스트
}

const getters = {
    ownerList(state){
      return state.ownerList
    }
}

const mutations = {
    OWNERLIST(state, payload){
        // 권리자 리스트
        state.ownerList = payload
    }
}


const actions = {
    GET_DDEXJOB: {
      root: true,
      handler(namespacedContext, payload) {
        return $api2({ method: 'get', url: '/admin/export-job', params: payload })
          .then(result => result.data)
      }
    },
    POST_DDEXJOB: {
        root: true,
        handler(namespacedContext, payload) {
            return $api2({ method: 'post', url: '/admin/export-job', data: payload.params })
              .then(result => result.data)
        }
    },
    PUT_DDEXJOB: {
        root: true,
        handler(namespacedContext, payload) {
            return $api2({ method: 'put', url: `/admin/export-job/${payload.id}`, data: payload.params })
              .then(result => result.data)
        }
    },
    GET_DDEXJOB_DETAIL: {
      root: true,
      handler(namespacedContext, payload) {
        return $api2({ method: 'get', url: `/admin/export-job/${payload.id}` })
          .then(result => result.data)
      }
    },
    GET_DDEXJOB_DETAIL_ALBUM: {
      root: true,
      handler(namespacedContext, payload) {
        return $api2({ method: 'get', url: `/admin/export-job/${payload.id}/album`, params: payload.params })
          .then(result => {
            // v2 returns a raw array of export_job_album rows with nested album; flatten to
            // the ej_*-prefixed flat shape that the detail.vue ag-grid columns expect.
            const raw = result.data
            const rows = Array.isArray(raw) ? raw : (raw.items || [])
            const items = rows.map(row => {
              const album = row.album || {}
              const artists = (album.album_artist || []).map(aa => ({
                display_name: (aa.artist && aa.artist.display_name) || aa.display_name || '',
              }))
              return {
                ...album,
                artists,
                id: album.id !== undefined ? album.id : row.album_id,
                ej_id: row.id,
                ej_batch_id: row.batch_id,
                ej_action: row.action,
                ej_state: row.state,
                ej_err_msg: row.err_msg,
              }
            })
            const total = Array.isArray(raw) ? items.length : (raw.filtered || raw.total || items.length)
            return { items, total, filtered: total }
          })
      }
    },
    POST_DDEXJOB_DETAIL_ALBUM: {
      root: true,
      handler(namespacedContext, payload) {
        return $api2({ method: 'post', url: `/admin/export-job/${payload.id}/album`, data: payload.params })
          .then(result => result.data)
      }
    },
    DELETE_DDEXJOB_DETAIL_ALBUM: {
      root: true,
      handler(namespacedContext, payload) {
        return $api2({ method: 'delete', url: `/admin/export-job/${payload.id}/album/${payload.album_id}` })
          .then(result => result.data)
      }
    },
    // ddex store
    GET_DDEX_CONTRACT: {
        root: true,
        handler(namespacedContext, payload) {
          return $api2({ method: 'get', url: '/admin/export-contract', params: payload })
            .then(result => {
              // v2 returns a raw array; wrap into the { items } shape the component expects.
              const data = result.data
              if (Array.isArray(data)) return { items: data, total: data.length, filtered: data.length }
              return data
            })
        }
    },
    START_DDEX:{
        root: true,
        handler(namespacedContext, payload) {
          return $api2({ method: 'post', url: `/admin/export-job/${payload.id}/start`, data: payload })
            .then(result => result.data)
        }
    },
    // Retry lives on data-portal v2 only ($api2). The v1 and v2 APIs share one
    // database, so the job id loaded via v1 matches the export_job row v2 retries.
    RETRY_DDEX:{
        root: true,
        handler(namespacedContext, payload) {
          return $api2({ method: 'post', url: `/admin/export-job/${payload.id}/retry`, data: payload.params
        })
            .then(result =>{
              return result.data
            })
        }
    },


    GET_BLACKLIST_LABEL: {
      root: true,
      handler(namespacedContext, payload) {
        return $api({ method: 'get', url: '/blacklist_label', params: payload
      })
          .then(result =>{
            return result.data
          })
      }
    },
    POST_BLACKLIST_LABEL: {
      root: true,
      handler(namespacedContext, payload) {
        return $api({ method: 'post', url: `/blacklist_label`, data: payload.params
      })
          .then(result =>{
            return result.data
          })
      }
    },
    DELETE_BLACKLIST_LABEL: {
      root: true,
      handler(namespacedContext, payload) {
          return $api({ method: 'delete', url: `/blacklist_label/${payload.id}`, data: payload.params
      })
          .then(result =>{
              return result.data
          })
      }
    },
    GET_BLACKLIST_GENRE: {
      root: true,
      handler(namespacedContext, payload) {
        return $api({ method: 'get', url: '/blacklist_genre', params: payload
      })
          .then(result =>{
            return result.data
          })
      }
    },
    POST_BLACKLIST_GENRE: {
      root: true,
      handler(namespacedContext, payload) {
        return $api({ method: 'post', url: `/blacklist_genre`, data: payload.params
      })
          .then(result =>{
            return result.data
          })
      }
    },
    DELETE_BLACKLIST_GENRE: {
      root: true,
      handler(namespacedContext, payload) {
          return $api({ method: 'delete', url: `/blacklist_genre/${payload.id}`, data: payload.params
      })
          .then(result =>{
              return result.data
          })
      }
    },
    GET_BLACKLIST_ARTIST: {
      root: true,
      handler(namespacedContext, payload) {
        return $api({ method: 'get', url: '/blacklist_artist', params: payload
      })
          .then(result =>{
            return result.data
          })
      }
    },
    POST_BLACKLIST_ARTIST: {
      root: true,
      handler(namespacedContext, payload) {
        return $api({ method: 'post', url: `/blacklist_artist`, data: payload.params
      })
          .then(result =>{
            return result.data
          })
      }
    },
    DELETE_BLACKLIST_ARTIST: {
      root: true,
      handler(namespacedContext, payload) {
          return $api({ method: 'delete', url: `/blacklist_artist/${payload.id}`, data: payload.params
      })
          .then(result =>{
              return result.data
          })
      }
    },
    
  }
  
  export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
  }
  